import React from 'react';

export const FigmaSearchResultIcon = () => (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_2230_18930)">
			<g clipPath="url(#clip1_2230_18930)">
				<path
					d="M14.8021 35C17.5621 35 19.8021 32.76 19.8021 30V25H14.8021C12.0421 25 9.80206 27.24 9.80206 30C9.80206 32.76 12.0421 35 14.8021 35Z"
					fill="#0ACF83"
				/>
				<path
					d="M9.80206 20C9.80206 17.24 12.0421 15 14.8021 15H19.8021V25H14.8021C12.0421 25 9.80206 22.76 9.80206 20Z"
					fill="#A259FF"
				/>
				<path
					d="M9.80206 10C9.80206 7.24 12.0421 5 14.8021 5H19.8021V15H14.8021C12.0421 15 9.80206 12.76 9.80206 10Z"
					fill="#F24E1E"
				/>
				<path
					d="M19.8019 5H24.8019C27.5619 5 29.8019 7.24 29.8019 10C29.8019 12.76 27.5619 15 24.8019 15H19.8019V5Z"
					fill="#FF7262"
				/>
				<path
					d="M29.8019 20C29.8019 22.76 27.5619 25 24.8019 25C22.0419 25 19.8019 22.76 19.8019 20C19.8019 17.24 22.0419 15 24.8019 15C27.5619 15 29.8019 17.24 29.8019 20Z"
					fill="#1ABCFE"
				/>
			</g>
		</g>
		<defs>
			<clipPath id="clip0_2230_18930">
				<rect width="30" height="30" fill="white" transform="translate(5 5)" />
			</clipPath>
			<clipPath id="clip1_2230_18930">
				<rect width="30" height="30" fill="white" transform="translate(5 5)" />
			</clipPath>
		</defs>
	</svg>
);
